package de.emgress.baskets

import de.emgress.baskets.core.styles.Styles
import de.emgress.baskets.modules.schedule.GamesSchedule
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.renderComposable

fun main() {
    renderComposable(rootElementId = "content") {
        Style(Styles.cssClasses)
        GamesSchedule()
    }
}
